import { Dialog } from "construct-ui";
import SingleSelectComponent from "../../components/single-select/single-select.component";
import goodMovementModel from "../../models/posm/goods-movement.model";
import POSMAuthorizationModel, { POSM_PERMISSION_KEY } from "../../models/posm/posm-authority.model";
import { MOVEMENT_TYPES } from "../../models/posm/posm.constant";
import ViewBase from "../view-base.view";
export default function POSMmovementTypeView() {
  const BOOTSTRAP_INVALID_CLASS = 'is-invalid';
  ViewBase.call(this);
  let currentInputMovementOrder = 0;
  const DEFAULT_ITEM_ONSELECT = { code: "", name: "Please select" }
  const dialogTitle = [
    {
      code: "LT00001294",
      content: "New Warehouse"
    },
    {
      code: "LT00001295",
      content: "New Storage Location"
    }
  ]

  const CATEGORY_ORDER = {
    MOVEMENT_TYPES: 0,
    WAREHOUSE: 1,
    STORARE_LOCATION: 2,
  };
  let movementDetail = structuredClone({
    movementType: goodMovementModel?.movementDetail?.movementType,
    warehouse: goodMovementModel?.movementDetail?.warehouse,
    storageLocation: goodMovementModel?.movementDetail?.storageLocation,
  });
  let isCreateDialogOpen = false
  let storageLocationObj = {
    Type: '',
    CateName: '',
    WarehouseId: '',
  }
  const resetMovementDetailMovement = (inputMovementOrder) => {
    let currentIndex = 0;
    for (const prop in movementDetail) {
      if (currentIndex >= CATEGORY_ORDER.MOVEMENT_TYPES) {
        if (currentIndex > inputMovementOrder) {
          movementDetail[prop] = { code: null, name: null };
        }
      }
      currentIndex++;
    }
    goodMovementModel.setMovementDetail(movementDetail);
  };

  const onSave = (e) => {
    e.preventDefault();
    let input = document.getElementById('input')
    if (!input?.value) {
      input?.classList.add(BOOTSTRAP_INVALID_CLASS)
      return;
    }
    addPosmStorageLocation(input, movementDetail?.warehouse?.code, currentInputMovementOrder)

  }
  const handleInput = (e) => {
    let input = document.getElementById('input')
    if (input?.value) {
      input?.classList.remove(BOOTSTRAP_INVALID_CLASS)
    }
  }
  const addPosmStorageLocation = (input, wareHouseId, currentIndex) => {
    let type = currentIndex == CATEGORY_ORDER.WAREHOUSE ? "Warehouse" : "StorageLocation"
    wareHouseId = currentIndex == CATEGORY_ORDER.WAREHOUSE ? 0 : wareHouseId;
    this.showLoading();
    goodMovementModel.addPosmStorageLocation({ ...storageLocationObj, CateName: input?.value, Type: type, WarehouseId: wareHouseId })
      .then((data) => {
        if (data[0].transStatus == "SUCCESS") {
          this.showMessage('success', null, () => {
            isCreateDialogOpen = false;
          });
        } else {
          this.showErrorMessage(data[0].message, null, () => {
          })
        }
        if (currentIndex == CATEGORY_ORDER.WAREHOUSE) {
          getAllWareHouse();
        } else {
          getAllStorageLocation(movementDetail?.warehouse?.code);
        }
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading()
      })

  }
  const onSelect = (s, categoryName, categoryOrderName, categoryOrderChildName, categoryChildName) => {
    const oldCode = movementDetail[categoryName].code;
    movementDetail[categoryName] = s;
    goodMovementModel.setMovementDetail(movementDetail);
    if (s.code) {
      if (s.code != oldCode) {
        if (categoryName == "warehouse") {
          this.showLoading();
          getAllStorageLocation(movementDetail.warehouse.code);
        }
        currentInputMovementOrder =
          CATEGORY_ORDER[categoryOrderChildName];
        resetMovementDetailMovement(
          currentInputMovementOrder
        );
        movementDetail[categoryChildName] = { code: null, name: null };
        resetMovementDetailMovement(
          currentInputMovementOrder
        );
      }
    } else {
      currentInputMovementOrder =
        CATEGORY_ORDER[categoryOrderName];
      resetMovementDetailMovement(
        currentInputMovementOrder
      );
    }

  }
  const getAllWareHouse = () => {
    goodMovementModel.getCommonForPopup({ DataType: 'POSM_WAREHOUSE', DataCode: '', DataName: '', ParameterDataCode: '' }).then((data) => {
      goodMovementModel.warehouse = data.data;
    }).catch((err) => {
      this.handleError(err);
    }).finally(
      () => {
        this.hideLoading();
      }
    );
  }
  const getAllStorageLocation = (wareHouseId) => {
    goodMovementModel.getCommonForPopup({ DataType: 'POSM_STORAGE', DataCode: "", DataName: '', ParameterDataCode: wareHouseId }).then((data) => {
      goodMovementModel.storageLocation = data.data;
    }).catch((err) => {
      this.handleError(err);
    }).finally(() => {
      this.hideLoading()
    })
  }
  const getCurrentParent = () => {
    let currentIndex = 0;
    let parentCode = '';
    let currentProp = '';
    for (const prop in movementDetail) {
      if (currentIndex >= CATEGORY_ORDER.MOVEMENT_TYPES) {
        if (!movementDetail[prop]?.code) {
          currentInputMovementOrder = currentIndex;
          currentProp = prop;
          break;
        } else {
          parentCode = movementDetail[prop]?.code;
        }
      }
      currentIndex++;
    }
    return {
      currentIndex,
      parentCode,
      currentProp
    }
  }
  return {
    oninit: ({ attrs: { clearMovementType } }) => {
      const currentParentObj = getCurrentParent();
      currentInputMovementOrder = currentParentObj.currentIndex;
      getAllWareHouse();
      if (currentInputMovementOrder == CATEGORY_ORDER.STORARE_LOCATION) {
        getAllStorageLocation(movementDetail?.warehouse?.code);
      }
      clearMovementType(() => { onSelect({ code: null, name: null }, "movementType", "MOVEMENT_TYPES", "WAREHOUSE", "warehouse") })
    },
    view: () => [
      m('.row.row-cols-5.g-2.align-items-center',
        m('.col.position-relative',
          m('label.form-label', this.getText('LT00001284', 'Movement Type')),
          m('.input-group',
            m(SingleSelectComponent, {
              popoverAttrs: { class: 'posm-filters' },
              items: MOVEMENT_TYPES,
              selectedItem: movementDetail.movementType,
              checkmark: true,
              filterable: true,
              onSelect: (s) => {
                onSelect(s, "movementType", "MOVEMENT_TYPES", "WAREHOUSE", "warehouse")
              },
            })
          )
        ),
        m('.col.position-relative', currentInputMovementOrder >= CATEGORY_ORDER.WAREHOUSE && [
          m('label.form-label', this.getText('LT00001269', 'Warehouse')),
          m('.input-group',
            m(SingleSelectComponent, {
              activeIndex: (goodMovementModel.warehouse.findIndex((item) => { return item.code == movementDetail.warehouse.code }) + 1) || 0,
              popoverAttrs: { class: 'posm-filters' },
              allowEmpty: goodMovementModel.warehouse.length != 0,
              items: goodMovementModel.warehouse,
              selectedItem: movementDetail.warehouse.code ? movementDetail.warehouse : DEFAULT_ITEM_ONSELECT,
              checkmark: true,
              filterable: true,
              onSelect: (s) => {
                onSelect(s, "warehouse", "WAREHOUSE", "STORARE_LOCATION", "storageLocation")
              },
            }),
            !movementDetail.warehouse.code &&
            POSMAuthorizationModel.loadWithPOSMAuthority(
              m('button.btn.btn-sm.btn-primary',
                {
                  onclick: () => {
                    isCreateDialogOpen = true;
                  },
                },
                [m('i.bi.bi-plus-lg.me-0')]
              ),
              POSM_PERMISSION_KEY.NEW_WAREHOUSE
            )

          ),
        ]),
        m('.col.position-relative', currentInputMovementOrder >= CATEGORY_ORDER.STORARE_LOCATION && [
          m('label.form-label', this.getText('LT00001270', 'Storage Location')),
          m('.input-group',
            m(SingleSelectComponent, {
              activeIndex: (goodMovementModel.storageLocation.findIndex((item) => { return item.code == movementDetail.storageLocation.code }) + 1) || 0,
              popoverAttrs: { class: 'posm-filters' },
              allowEmpty: goodMovementModel.storageLocation.length != 0,
              items: goodMovementModel.storageLocation,
              selectedItem: movementDetail.storageLocation,
              checkmark: true,
              filterable: true,
              onSelect: (s) => {
                movementDetail.storageLocation = s;
                goodMovementModel.setMovementDetail(movementDetail);
              },
            }),
            !movementDetail.storageLocation.code &&
            POSMAuthorizationModel.loadWithPOSMAuthority(m('button.btn.btn-sm.btn-primary',
              {
                onclick: () => {
                  isCreateDialogOpen = true;
                },
              },
              [m('i.bi.bi-plus-lg.me-0')]
            ),
              POSM_PERMISSION_KEY.NEW_STORAGE
            )
          ),
        ]),
        m('.col.position-relative'),
        m('.col.position-relative'),

        m(Dialog, {
          isOpen: isCreateDialogOpen,
          closeOnOutsideClick: false,
          closeOnEscapeKey: false,
          title: this.getText(dialogTitle[currentInputMovementOrder - 1]?.code, dialogTitle[currentInputMovementOrder - 1]?.content),
          class: 'cui-dialog-xxl',
          onClose: () => {
            isCreateDialogOpen = false;
          },
          content: m('.card',
            m('.card-body',
              m('form.needs-validation[novalidate]', { id: 'form', onsubmit: onSave },
                m('.row.g-2',
                  m('.col-md-12.position-relative',
                    m('label.form-label.mandatory[for="input"]',
                      `${this.getText(dialogTitle[currentInputMovementOrder - 1]?.code, dialogTitle[currentInputMovementOrder - 1]?.content)}`
                    ),
                    m(`input#input.form-control.form-control-bg[required][type=text][placeholder=${this.getText(dialogTitle[currentInputMovementOrder - 1]?.code, dialogTitle[currentInputMovementOrder - 1]?.content)}]`
                      , {
                        maxlength: 100,
                        oninput: handleInput
                      }
                    ),
                    m('.invalid-tooltip', this.getText('LT00000903', 'Please check required fields')),
                  ),
                )
              )
            ),

          ),
          footer: m('row',
            m('.col-12.d-flex.justify-content-end.gap-2',
              m('button.btn.btn-primary',
                {
                  type: 'submit',
                  form: 'form',
                },
                this.getText('LT00000022', 'Save')
              ),
              m('button.btn.btn-white',
                {
                  onclick: () => {
                    isCreateDialogOpen = false;
                  },
                },
                this.getText('LT00000021', 'Close')
              )
            )
          ),
        }),
      ),
      this.getBaseViews(),
    ]
  }
}